import Vue from 'vue'
import { Resource } from '@/config/interfaces'
import { TOKEN_PIN } from '@/views/PinEnter.vue'
import Utils from '@/helpers/Utils'

export const SECONDARY = 'SECONDARY'

export const MultiResourceMixin = Vue.extend({
  methods: {
    switchIdentifier (resource: Resource): void {
      if (resource.primary) {
        sessionStorage.removeItem(SECONDARY)
      } else {
        sessionStorage.setItem(SECONDARY, resource.value)
      }
      sessionStorage.removeItem(TOKEN_PIN)
      this.$router.push({ name: 'Home' }).catch(() => { /* Redirect to home, catch warnings */ })
      Utils.reloadPage(this.$router) // Reload page
    }
  }
})
